import chroma from "chroma-js"
import { useTheme } from "@mui/material"

export const getTemperature = chroma.scale(["#cc0000", "#e6e41e", "#32c77f"])

export const darkenColor = (color, darken = 2) =>
  chroma(color)
    .darken(darken)
    .css()
export const brightenColor = (color, brighten = 2) =>
  chroma(color)
    .brighten(brighten)
    .css()
export const alphaColor = (color, alpha = 1) =>
  chroma(color)
    .alpha(alpha)
    .css()

export const isValidColor = c =>
  /^(#(?:[0-9a-f]{2}){2,4}|#[0-9a-f]{3}|(?:rgba?|hsla?)\((?:\d+%?(?:deg|rad|grad|turn)?(?:,|\s)+){2,3}[\s\\/]*[\d\\.]+%?\))$/i.test(
    c
  )
export const rgbToSafeStr = rgb => rgb.replace(/,|\(|\)|\s/g, "")

export const useColor =(color) => {
  const theme = useTheme()
  let activeColor = theme.palette.primary.light

  const seriesColors = theme.series

  if (typeof color === "number") {
    activeColor = seriesColors[color % seriesColors.length]
  } else if (color && isValidColor(color)) {
    activeColor = color
  } else if (
    color &&
    /primary|secondary|error|warning|info|spice|success/.test(color) &&
    color in theme.palette
  ) {
    activeColor = theme.palette[color].light
  }

  return activeColor
}
